import { styled } from '@mui/system'

export const Logo = styled('img')`
  width: 240px;
`
